/* eslint-disable consistent-return */
import React, { useState, useEffect, useRef } from 'react';

import Segment from './Segment';
import FilledButton from '../../../Buttons/FilledButton';
import MiniPlayer from './MiniPlayer';

import classes from './styles.module.scss';
import downloadIcon from '../../../../assets/images/reports/download.svg';
import useCheckMobileScreen from '../../../../hooks/useCheckMobileScreen';
import downloadIconBlack from '../../../../assets/images/reports/downloadBlack.svg';
import closeIcon from '../../../../assets/images/closeIconBlack.svg';
import { useUiStore } from '../../../../store';

export default function Transcript({
  transcript,
  setCommentsMode,
  videoRef,
  setIsPlaying,
  signedS3Url,
  meeting,
  videoDuration,
  isPlaying,
  audioSectionsWithoutBackground,
  miniVideoRef,
}) {
  const [currentSegmentId, setCurrentSegmentId] = useState(null);
  const [isMiniPlayerVisible, setIsMiniPlayerVisible] = useState(true);

  const transcriptContainer = useRef();

  const videoPlayerHeight = useUiStore((state) => state.videoPlayerHeight);

  useEffect(() => {
    if (!transcriptContainer.current) {
      return;
    }

    transcriptContainer.current.style.setProperty(
      '--video-player-height',
      `${videoPlayerHeight}px`
    );
  }, [videoPlayerHeight]);

  useEffect(() => {
    const watchVideoTime = () => {
      const currentSegment = transcript?.results?.audio_segments?.find(
        (segment) =>
          segment.start_time <= videoRef.current.currentTime &&
          segment.end_time >= videoRef.current.currentTime
      );

      if (currentSegment) {
        setCurrentSegmentId(currentSegment.id);
      }
    };
    if (!videoRef.current) {
      return;
    }

    videoRef.current.addEventListener('timeupdate', watchVideoTime);

    const currentVideoRef = videoRef.current;
    return () => {
      if (currentVideoRef) {
        currentVideoRef.removeEventListener('timeupdate', watchVideoTime);
      }
    };
  }, [transcript, videoRef]);

  const isMobile = useCheckMobileScreen();

  const downloadTranscript = () => {
    const segments = transcript?.results?.audio_segments || [];

    const formatTime = (time) => {
      const seconds = parseFloat(time);
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = Math.floor(seconds % 60)
        .toString()
        .padStart(2, '0');
      return `${minutes}:${remainingSeconds}`;
    };

    const csvRows = ['time,text'];

    segments.forEach((segment) => {
      const time = formatTime(segment.start_time);
      const text = segment.transcript.replace(/"/g, '""');
      csvRows.push(`${time},"${text}"`);
    });

    const csvContent = csvRows.join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = 'transcript.csv';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    URL.revokeObjectURL(url);
  };

  return (
    <div className={classes.Transcript} ref={transcriptContainer}>
      <div className={classes.container}>
        <header className={classes.header}>
          {isMobile && (
            <button
              type="button"
              onClick={() => setCommentsMode('engagements')}
            >
              <img src={closeIcon} alt="Close" />
            </button>
          )}
          <h3 className={classes.title}>Transcript</h3>
          <div className={classes.downloadButtonContainer}>
            {isMobile ? (
              <button type="button" onClick={downloadTranscript}>
                <img
                  src={downloadIconBlack}
                  alt="Export"
                  className={classes.exportIcon}
                />
              </button>
            ) : (
              <FilledButton width={196} onClick={downloadTranscript}>
                Export{' '}
                <img
                  src={downloadIcon}
                  alt="Export"
                  className={classes.exportIcon}
                />
              </FilledButton>
            )}
          </div>
        </header>
        <div className={classes.content}>
          <ul className={classes.list}>
            {transcript?.results?.audio_segments?.map((segment) => (
              <Segment
                key={segment.id}
                segment={segment}
                currentSegmentId={currentSegmentId}
                videoRef={videoRef}
                setIsPlaying={setIsPlaying}
                miniVideoRef={miniVideoRef}
              />
            ))}
          </ul>
          {isMiniPlayerVisible && (
            <div className={classes.videoPlayerContainer}>
              <MiniPlayer
                signedS3Url={signedS3Url}
                meeting={meeting}
                videoRef={videoRef}
                videoDuration={videoDuration}
                isPlaying={isPlaying}
                setIsPlaying={setIsPlaying}
                setIsMiniPlayerVisible={setIsMiniPlayerVisible}
                audioSectionsWithoutBackground={audioSectionsWithoutBackground}
                miniVideoRef={miniVideoRef}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
